export default str => {
  if (typeof str == "string") return str.replace(/[,$% ]+/g, "");
  return str;
};
